import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** Campi del contesto diagnosi inviati al motore AI (recommender + Stage 5). */
export const DIAGNOSIS_AI_CONTEXT_SECTIONS: { title: string; fields: string[] }[] = [
  {
    title: 'Azienda',
    fields: [
      'name',
      'ateco (priorità: 2025 → 2022 → 2007)',
      'type',
      'size_category',
      'high_electricity',
      'high_gas',
      'certifications',
      'avg_consumption_kwh',
    ],
  },
  {
    title: 'Usi energetici (da diagnosis_energy_use)',
    fields: [
      'code',
      'description',
      'significant',
      'relevance_1_5',
      'tech_gap_1_5',
      'pct',
    ],
  },
];

export const AiDiagnosisContextInfo: React.FC = () => (
  <Accordion disableGutters variant="outlined" sx={{ mb: 2 }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="caption" color="text.secondary">
        Contesto diagnosi inviato all&apos;AI
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Stack spacing={1.5}>
        <Typography variant="caption" color="text.secondary">
          Il contesto include solo il profilo aziendale (con ATECO) e gli usi energetici già
          identificati nella diagnosi.
        </Typography>
        {DIAGNOSIS_AI_CONTEXT_SECTIONS.map(section => (
          <Stack key={section.title} spacing={0.5}>
            <Typography variant="subtitle2">{section.title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {section.fields.join(' · ')}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </AccordionDetails>
  </Accordion>
);
